import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CheckoutListModule } from '@draeger-academy/presentation/lib/modules/checkout-list';
import { DaLinkModule } from '@draeger-academy/presentation/lib/modules/da-link';
import { HotelsListModule } from '@draeger-academy/presentation/lib/modules/hotels-list';
import { LoginFormModule } from '@draeger-academy/presentation/lib/modules/login-form';
import { PersonCardModule } from '@draeger-academy/presentation/lib/modules/person-card';
import { PersonFormModule } from '@draeger-academy/presentation/lib/modules/person-form';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { TranslateModule } from '@ngx-translate/core';
import { BookingParticipantsComponent } from './booking-participants/booking-participants.component';
import { BookingPersonComponent } from './booking-person/booking-person.component';
import { StepsComponent } from './booking-steps-legend/steps.component';
import { BookingSummaryComponent } from './booking-summary/booking-summary.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { BookingConfirmationComponent } from './booking-confirmation/booking-confirmation.component';
import { LoginPopupComponent } from './booking-person/login-popup/login-popup.component';
import { ChecklistEmployeesComponent } from './booking-participants/checklist-employees/checklist-employees.component';
import { ParticipantsListComponent } from './booking-participants/participants-list/participants-list.component';
import { BookingPaymentComponent } from './booking-payment/booking-payment.component';
@NgModule({
    declarations: [
        BookingConfirmationComponent,
        BookingPersonComponent,
        BookingParticipantsComponent,
        BookingSummaryComponent,
        CheckoutComponent,
        LoginPopupComponent,
        StepsComponent,
        ChecklistEmployeesComponent,
        ParticipantsListComponent,
        BookingPaymentComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        PersonFormModule,
        LoginFormModule,
        HotelsListModule,
        DaLinkModule,
        CheckoutListModule,
        PersonCardModule,
        FormsModule,
        TranslateModule.forChild(),
        RouterModule.forChild([]),
        LocalizeRouterModule.forChild([])
    ],

    exports: [
        BookingConfirmationComponent,
        BookingPersonComponent,
        BookingParticipantsComponent,
        BookingSummaryComponent,
        CheckoutComponent,
        StepsComponent,
        ChecklistEmployeesComponent,
        ParticipantsListComponent,
        BookingPaymentComponent
    ]
})
export class BookingModule {}
